module.exports = __webpack_public_path__ + "static/media/veado.fa4b9c62.mp3";